import React from 'react';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

//import components
import HeadingsTitleSearchFormField from './HeadingsTitleSearchFormField.js';

//img
import search from '../../assets/icons/search-light.svg';
import searchDark from '../../assets/icons/search.svg';

const HeadingsTitleSearchForm = ({ handleSubmit, submitting, clang, pristine, currentKey }) => {
    return (
        <form onSubmit={handleSubmit} className="headings-search__form">
            <Field component={HeadingsTitleSearchFormField} type="text" name="key" placeholder={lang[clang].characteristics.search} label={lang[clang].characteristics.search_in}/>
            <button type="submit" disabled={currentKey === '' || submitting} className="headings-search__form-submit" title={lang[clang].search_for}>
                <img src={search} alt="" className="headings-search__form-submit__img"/>
                <img src={searchDark} alt="" className="headings-search__form-submit__img hover"/>
            </button>
        </form>
    );
};

HeadingsTitleSearchForm.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(reduxForm({
    form: 'headings-title-search',
    enableReinitialize: true
})(HeadingsTitleSearchForm));



// WEBPACK FOOTER //
// ./src/components/characteristics/HeadingsTitleSearchForm.js